import React from 'react';

const Page = ({ children, singleMode, id, style }) => (
  <div id={id} className="mt-2" style={style || null}>
    {children}
  </div>
);

export default Page;
